"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stopwatch = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Stopwatch = function Stopwatch() {
  return react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5762 6.44295L21.9587 5.08717C22.1919 4.85391 22.1919 4.48058 21.9587 4.24731L21.09 3.39545C20.9752 3.28188 20.8188 3.218 20.6557 3.218C20.4926 3.218 20.3362 3.28188 20.2213 3.39545L18.8632 4.79922C17.5767 3.77539 16.0711 3.04947 14.4586 2.67557V1.19981C14.4586 0.537171 13.9108 0 13.2351 0H10.7881C10.1124 0 9.56457 0.537171 9.56457 1.19981V2.67557C4.55652 3.79489 1.00283 8.16089 1 13.1979C1.06674 19.0141 5.76684 23.7602 11.6935 23.9961C15.9812 24.1087 19.9455 21.7695 21.8522 18.0017C23.7588 14.234 23.2609 9.72334 20.5762 6.44295ZM12.0113 21.5966C7.28122 21.5966 3.44673 17.8364 3.44673 13.198C3.44673 8.55951 7.28122 4.79932 12.0113 4.79932C16.7414 4.79932 20.5759 8.55951 20.5759 13.198C20.5759 17.8364 16.7414 21.5966 12.0113 21.5966ZM11.5464 7.19873H12.4763C12.8141 7.19873 13.088 7.46732 13.088 7.79863V13.7977C13.088 14.129 12.8141 14.3976 12.4763 14.3976H11.5464C11.2085 14.3976 10.9347 14.129 10.9347 13.7977V7.79863C10.9347 7.46732 11.2085 7.19873 11.5464 7.19873Z",
    fill: "currentColor"
  });
};

exports.Stopwatch = Stopwatch;